import React, { useContext, useRef, useState, useEffect } from 'react';
import styled from 'styled-components';
import { Dialog, Item } from '@zebra-fed/zds-react-desktop';
import { SnackbarContent } from "../../styled-components/shared";
import firebaseUtil from '../../data/FirebaseUtil';
import TextField from '@material-ui/core/TextField';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Snackbar from '@material-ui/core/Snackbar';
import '@zebra-fed/icons/Alert/index.css';
import { useTranslation } from "react-i18next";
import { MessageResponseContext } from "../../data/MessageLocalizationProvider";

import FreeSelect from '../DropdownFreeSize';

import { AuthContext } from '../../authentication/Auth';
import app from '../../authentication/firebaseStart';


const firestore = app.firestore();
const ModalHeader = styled.div`
    display: flex;
    flex-direction: row;
    height: 50px;
    font-size: 18px;
    background-color: #007ABA;
    color: white;
    align-items: center;
    padding: 0 24px;    
    justify-content: center;
`

const MainContent = styled.div`
  margin-top: 0;
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const StyledTextField = styled(TextField)`
  width: 220px;
  display: flex;
`;

const RoleSelector = styled(FormControl)`
    width: 220px;
    padding-top: 8px;
`

const ElementWrapper = styled.div`
    display: flex;
    padding-top: 8px;
`

export default function EditManUserModal(props) {
    const dialogRef = props.modalRef;
    const managerData = props.managerDatas;
    const { t } = useTranslation();
    const { getKeyItem } = useContext(MessageResponseContext);

    const context = useContext(AuthContext);
    const [allSiteNames, setAllSiteNames] = useState([{ label: "No Site", value: "" }])
    const [sitesOld, setSitesOld] = useState([{ label: "No Site", value: "" }])
    const [sitesFilterVal, setSitesFilterVal] = useState({});
    const [singleUser, setSingleUser] = useState({
        email: "",
        authType: "",
        siteName: "",
        role: "None"
    });

    useEffect(() => {
        getSitesData();
        getAppSettings();
    }, []);

    const [checkErrors, setCheckErrors] = useState(false);
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isSSO, setSSO] = useState(false);
    const errors = useRef([]);
    const serverMessage = useRef('');
    
    async function getAppSettings(){
        let companyID = context.currentUser.claims.companyID;
        console.log("Getting App Settigs");
        let appSettings = (
          await firestore.collection('tenants').doc(companyID).collection('Configuration').doc('AppSettings').get()
        ).data();
        setSSO(appSettings ? appSettings.SSOActivationStatus : false);
        console.log("IsSSO:"+ isSSO);
        console.log("App Settings:",appSettings);   
    
    }
    function onSubmit() {
        errors.current = [];
        uploadData();
    }

    function clearForm() {
        setSingleUser({ siteName: "" });
        setCheckErrors(false);
        errors.current = [];
        setAllSiteNames(sitesOld);
    }

    async function getSitesData() {
        let companyID = context.currentUser.claims.companyID;
        var siteLocations = firestore.collection('tenants').doc(companyID).collection("SiteLocations").limit(10);
        var sitesData = [];
        try {
            var siteLocationsSnapShot = await siteLocations.get();
            var sitesData = [];
            siteLocationsSnapShot.forEach(doc => {
                if (doc.data().displaySiteName !== "")
                    sitesData.push({ 'label': doc.data().siteName, 'value': doc.data().displaySiteName });
            });
            setAllSiteNames(sitesData);
            setSitesOld(sitesData);
        }
        catch (err) {
            console.log('Error getting documents', err);
        }
    }

    function handleCancel() {
        dialogRef.current.toggleDialog();
        setSitesFilterVal({});
        clearForm();
        setAllSiteNames(sitesOld)
    }

    async function uploadData() {
        let para = {
            email: managerData.email,
            siteName: singleUser.siteName,
            displaySiteName: singleUser.displaySiteName
        }
        let companyID = context.currentUser.claims.companyID;        
        props.onUpdateSite(para);
        setIsLoading(true);
        let siteName = "No Site";
        if (singleUser.siteName === "No Site") {
        }
        else {
            let selectedSiteName = singleUser.siteName;

            let myQry = (
                await firestore
                    .collection('tenants')
                    .doc(companyID)
                    .collection('SiteLocations')
                    .where('siteName', '==', selectedSiteName)
                    .get()
            ).docs.map((doc) => doc.data());
            siteName = myQry[0].siteName;
        }


        let response = await firebaseUtil.updateManager(singleUser, siteName, t);
        setIsLoading(false);
        if (response.status) {
            props.onClose();
            clearForm();
            dialogRef.current.toggleDialog();
            setSitesFilterVal({});

        } else {
            serverMessage.current = getKeyItem(response.msg);
            setSnackbarOpen(true);
        }
        
    }

    function onFilterChange(e) {
        console.log('site optoin changed mmm')
        let opted = e.label;
        if (opted === 'No Site') {
            //setData(dataOld)
        }
        console.log(e, 'e.target')
        setSitesFilterVal(e);
        // setAllSiteNames(sitesOld);
        setSingleUser({ ...singleUser, email: managerData.email,authType: managerData.authType, siteName: e.label, displaySiteName: e.value })
    }

    async function getSelectInputSearch(rawInput, type) {


        try {
            let companyID = context.currentUser.claims.companyID;
            if (type === 'ENTERHIT' && rawInput) {
                let sites = [];
                setIsLoading(true);

                sites = (
                    await firestore
                        .collection('tenants')
                        .doc(companyID)
                        .collection('SiteLocations')
                        .orderBy('siteName')
                        .startAt(rawInput.toUpperCase()).endAt(rawInput.toUpperCase() + "\uf8ff")
                        .limit(10)
                        .get()
                ).docs.map((doc) => doc.data());
                //{ label: "Select Site", value: "" }
                let finalSitesArray = [];
                if (sites.length > 0) {
                    sites.forEach(element => {
                        console.log(element)
                        finalSitesArray.push({ label: element.siteName, value: element.displaySiteName })
                    });
                }
                setAllSiteNames(finalSitesArray)
                setIsLoading(false);
            }
        } catch (err) { console.log(err, 'errorrororo') }

        // if (type === 'ENTERHIT') {
        //     let customFil = allSiteNames.filter(
        //         value => {
        //             return (
        //                 value
        //                     .value
        //                     .toLowerCase() ===
        //                 (rawInput.toLowerCase())
        //             );
        //         });
        //     if (customFil.length === 0) {
        //         searchSiteName(rawInput)
        //     }
        //     else {
        //         setAllSiteNames(customFil)
        //     }
        // } else if (type === 'EMPTY') {
        //     setAllSiteNames(sitesOld)
        // }
    }



    function customFilterSearch(option, rawInput) {
        return allSiteNames;
    }

    const ButtonStyle = {
        cursor: isLoading ? 'wait' : 'pointer',
    }
    let siteDefaultValue = {
        "label": props?.managerDatas?.siteName,
        "value": props?.managerDatas?.siteName
    }
    return (
        <>
            <Dialog ref={dialogRef}
                key='dialog2'
                width='520px'
                items={[
                    <Item type='button' style={{ ...ButtonStyle, backgroundColor: '#757575', width: '102px' }} onClick={handleCancel} disabled={isLoading}>{t("cancel")}</Item>,
                    <Item type='button' style={ButtonStyle} onClick={onSubmit} disabled={isLoading}>{t('save')}</Item>,
                ]}
                headerStyle={{ display: 'none' }}
                bodyStyle={{ padding: '0px', width: '100%' }}
                cardStyle={{ marginBottom: '80px' }}
                style={{ cursor: isLoading ? 'wait' : 'default' }}>
                <ModalHeader>
                    {t('edit_site_dialog_heading')}
                </ModalHeader>
                <MainContent>
                    <ElementWrapper style={{ paddingTop: '16px' }}>
                        <RoleSelector>
                            <InputLabel htmlFor="role-selector">{t('role')}</InputLabel>
                            <Select
                                native
                                value={t('manager')}
                                defaultValue={t('manager')}
                                inputProps={{
                                    name: 'role',
                                    id: 'role-selector',
                                }}
                                disabled={true}
                            >
                                <option value={'manager'}>{t('manager')}</option>
                            </Select>
                        </RoleSelector>
                    </ElementWrapper>
                    <ElementWrapper>
                        <StyledTextField
                            // inputProps={{
                            //         name: 'email',
                            //         id: 'email',
                            // }}
                            InputLabelProps={{ shrink: true }}
                            label={t('email')}
                            value={managerData.email}
                            //defaultValue={managerData.email}
                            //disabled="true"
                            type="email"
                            variant="filled"
                        //autoFocus={true}
                        //tabIndex={0}
                        />
                    </ElementWrapper>

                    <div className="AddUsersDropdown" style={{
                        display: 'flex',
                        paddingTop: '8px',
                        width: '220px'
                    }}>
                        <FreeSelect
                            selectOpts={allSiteNames}
                            // defaultValue={allSiteNames[0]}
                            onChange={(e) => onFilterChange(e)}
                            //resetSelect={resetCusSelect}
                            selectVal={sitesFilterVal.label ? sitesFilterVal : siteDefaultValue}
                            //selectVal={siteDefaultValue}
                            isSearchable={true}
                            onSearchInpChange={getSelectInputSearch}
                            isLoading={isLoading}
                            customFilterOption={customFilterSearch}
                            selectOnBlur={() => setAllSiteNames(sitesOld)}
                            changeHeight = {true} 
                        />
                    </div>
                </MainContent>
                <Snackbar open={snackbarOpen} autoHideDuration={3000} onClose={() => setSnackbarOpen(false)}>
                    <SnackbarContent error={true}>{serverMessage.current}</SnackbarContent>
                </Snackbar>
            </Dialog>
        </>
    )
}